export const main_dashboard = [
    {
        element: '.welcome',
        popover: {
            title: 'Welcome',
            description: 'Welcome to Main Dahboard',
            position: 'left',
        },
    },
    {
        element: '.date_filter',
        popover: {
            title: 'Date Filter',
            description: 'Use this filter to view data from the past 30, 60, 90, or 180 days, or select a custom date range to analyze a specific period.',
            position: 'left',
        },
    },
    {
        element: '.notification',
        popover: {
            title: 'Notifications',
            description: 'Get notified whenever a new post, campaign, or ad is detected on your connected accounts.',
            position: 'left',
        },
    },
    {
        element: '.sync_data',
        popover: {
            title: 'Sync Now',
            description: 'Manually refresh and fetch the most recent data from your connected social platforms..',
            position: 'left',
        },
    },
    {
  element: '.btn-reset-tour',
  popover: {
    title: 'Reset Tour',
    description: 'Click this button anytime to restart the tour and revisit key features across the system.',
    position: 'left',
  },
},

    // {
    //     element: '.paid_social',
    //     popover: {
    //         title: 'Paid Social Media',
    //         description: 'This provides a metrics about over a provided period of time',
    //         position: 'right',
    //     },
    // },
    // {
    //     element: '.paid_media',
    //     popover: {
    //         title: 'Paid Media',
    //         description: 'This provides a metrics about over a provided period of time',
    //         position: 'right',
    //     },
    // },
    // {
    //     element: '.owned_media',
    //     popover: {
    //         title: 'Owned Media',
    //         description: 'This provides a metrics about over a provided period of time',
    //         position: 'right',
    //     },
    // },
    // {
    //     element: '.search',
    //     popover: {
    //         title: 'Search',
    //         description: 'This provides a metrics about over a provided period of time',
    //         position: 'right',
    //     },
    // },
    // {
    //     element: '.total_metrics',
    //     popover: {
    //         title: 'Total Metrics Overview',
    //         description: 'This provides a metrics about over a provided period of time',
    //         position: 'right',
    //     },
    // },
    // {
    //     element: '.chart-section',
    //     popover: {
    //         title: 'Performance Summary',
    //         description: 'Visual breakdown of Clicks, Impressions, and Spend across Paid Social, Paid Media, and Organic Social.',
    //         position: 'bottom',
    //     },
    // },
    // {
    //     element: '#overview-section',
    //     popover: {
    //         title: 'Connected Accounts Overview',
    //         description: 'See how many social accounts, ads, posts, and analytics URLs are connected across platforms.',
    //         position: 'top',
    //     },
    // },
    // {
    //     element: '.paid_social_media_overview',
    //     popover: {
    //         title: 'Paid Social Summary',
    //         description: 'Total spend, impressions, and clicks from Facebook, Instagram, and LinkedIn campaigns.',
    //         position: 'bottom',
    //     },
    // },

    // {
    //     element: '.organic_social_overview',
    //     popover: {
    //         title: 'Organic Social Overview',
    //         description: 'This section gives you a summary of total shares, clicks, and impressions from organic posts across Facebook, Instagram, and LinkedIn.',
    //         position: 'bottom',
    //     },
    // },
  
    // {
    //     element: '.platform_performance_overview',
    //     popover: {
    //         title: 'Platform Engagement Performance',
    //         description: 'Bar charts comparing engagement rates across platforms for both Paid and Organic social content.',
    //         position: 'left',
    //     },
    // },
    // {
    //     element: '.google_ads_overview',
    //     popover: {
    //         title: 'Google Ads Overview',
    //         description: 'Track your total spend, impressions, clicks, and conversions from Google Ads campaigns. Currently, the performance is at $0.',
    //         position: 'left',
    //     },
    // },
    // {
    //     element: '.google_analytics_overview',
    //     popover: {
    //         title: 'Google Analytics Overview',
    //         description: 'Track your total spend, impressions, clicks, and conversions from Google Ads campaigns. Currently, the performance is at $0.',
    //         position: 'left',
    //     },
    // }
       {
        element: '.settings',
        popover: {
            title: 'Settings',
            description: 'Use the settings page to edit your profile, update client data, and manage your team by adding or removing users as needed.',
            position: 'right',
        },
    }

]




